<template>
    <div>   
        <v-divider></v-divider> 
        <mbs-page-tab 
            :items="MY_LINKS"/> 
        <v-divider></v-divider> 
        <v-divider></v-divider> 
        <v-divider></v-divider> 
        <v-container grid-list-xl> 
            <v-layout align-center="" justify-center="">
                <v-col sm="12" cols="12">
                    <br>
                    <v-card > 
                        <mbs-item-manager
                            :table_title="'Manage Outlet'"
                            :table_title_icon="'mdi-sitemap'"
                            :add_vertical_lines="true"
                            :row_click="true"
                            :top_label="false"
                            :name_items="NAME_ITEMS"
                            :name_item="NAME_ITEM"
                            :value_items="VALUE_ITEMS"
                            :value_item="VALUE_ITEM"
                            :receive_selected_excel="VALUE_ITEMS"
                            :field_items="DATA.FIELDS.outlets"
                            :header_items="HEADER_ITEMS"
                            :header_items2="HEADER_ITEMS2"
                            :data_items="DataItems"   
                            :is_joined="true"   
                            :path_item="PATH_ITEM"  
                            :select_items="ItemSelector" 
                            :table_actions="table_actions" 
                            @SELECT_TABLE_ACTION="TABLE_ACTION"
                            @SELECT_ITEM_ACTION="ITEM_ACTION"
                        />
                    </v-card>
                    <br><br>
                </v-col>  
            </v-layout>
        </v-container>  


        <div v-if="ADDING_ITEM">
            <mbs-item-manager 
                :show="false" 
                :table_title="'Update Outlet'"
                :add_item_action="ADDING_ITEM.add_item_action"
                :edit_item_action="ADDING_ITEM.edit_item_action"
                :name_items="ADDING_ITEM.names"
                :name_item="ADDING_ITEM.name"
                :value_items="ADDING_ITEM.values"
                :value_item="ADDING_ITEM.value"
                :field_items="ADDING_ITEM.fields"   
                :data_items="DataItems"  
                :is_joined="true" 
                :path_item="ADDING_ITEM.path"  
                :select_items="ItemSelector"   
            /> 
        </div>

    </div> 
</template>

<script>
    import DATA from '../../../plugins/DATA'
    import { mdiInformationVariantBoxOutline } from '@mdi/js';
    import {mapState} from "vuex"
    let PAGE_NAME = DATA.ITEMS.STOCK_OUTLETS.values    
    export default {
        name:PAGE_NAME, 
        data() {
            return {
                PAGE_LOAD:false,  
                PAGE_CURRENT:1,
                PAGE_SIZE:10,

                NAME_ITEMS:DATA.ITEMS.STOCK_OUTLETS.names,
                NAME_ITEM:"_"+DATA.ITEMS.STOCK_OUTLETS.name,
                VALUE_ITEMS:DATA.ITEMS.STOCK_OUTLETS.values,
                VALUE_ITEM:DATA.ITEMS.STOCK_OUTLETS.value,  
                DATA:DATA,

                FIELD_ITEMS:[
                    {type:"number",value:"code",label:"Code",required:true,sm:12,md:6}, 
                    {type:"text",value:"name",label:"Name",required:true,sm:12,md:6},   
                    {type:"text",value:"location_address",label:"Location Address",required:true,sm:12,md:12},   
                    // {type:"text",value:"default_tax",label:"Default Tax",required:true,sm:12,md:6},   
                    // {type:"text",value:"saleing_price",label:"Saleing",required:true,sm:12,md:12},   
                    {type:"textarea",value:"description",label:"Description",required:true,sm:12,md:12},   
                ],   
                ADDING_ITEM:null,  
            }
        },
        created() {
            try {
                this.MBS.events.$on('DIALOG_YES', this.DIALOG_YES);  
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:PAGE_NAME, 
                }) 
            }
        },
        mounted() {
            try {
                this.MBS.actions.header({
                    show:true,
                    type:'subToolbar', 
                    images:null,
                    color:'black',
                    height:"300",
                    opacity:'0.1'
                }) 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'mounted',
                    page:PAGE_NAME, 
                }) 
            }  
        },
        computed: {
            route(){
                return this.$route
            },
            vs(){
                return this.$vuetify.breakpoint
            }, 
            vsh(){
                return this.vs.height
            }, 
            table_actions(){
                const outlets = this.DataItems
                const actions = [
                    {type:"btn",action:"add_stock_outlet",color:"secondary", outlined:false,  text:"Add Outlet"}, 
                    {type:"action",icon:"mdi-import",action:"import_excel",color:"secondary", outlined:false,  text:"Import Excel"},  
                    {type:"action",icon:"mdi-microsoft-excel",action:"export_excel",color:"secondary", outlined:false,  text:"Export to Excel"},  
                    {type:"action",icon:"mdi-database-refresh",action:"refresh_with_outlet_stock",color:"secondary", outlined:false,  text:"Refresh with Outlets"}, 
                ] 
                const actions2 = [
                    {type:"btn",action:"initialize_main_warehouse",color:"secondary", outlined:false,  text:"Initialize Main Warehouse"}, 
                    {type:"btn",action:"add_stock_outlet",color:"secondary", outlined:false,  text:"Add Outlet"}, 
                    {type:"action",icon:"mdi-import",action:"import_excel",color:"secondary", outlined:false,  text:"Import Excel"},  
                    {type:"action",icon:"mdi-microsoft-excel",action:"export_excel",color:"secondary", outlined:false,  text:"Export to Excel"},  
                    {type:"action",icon:"mdi-database-refresh",action:"refresh_with_outlet_stock",color:"secondary", outlined:false,  text:"Refresh with Outlets"}, 
                ] 
                if (outlets?.findIndex(item=>item.key=="0")==-1) {
                    return actions2
                }
                return actions
            },
            /////////
            ...mapState({
                loading:state=>state.load.loading,
                processes:state=>state.load.processes,
                responses:state=>state.load.responses,
            }),
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
            }),
            ...mapState({
                Outlets: state=> state.items[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()], 
                JoinedOutlets: state=> state.join[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()], 
                OutletTypes: state=> state.app['OUTLET_TYPES'], 
                CashupOptions: state=> state.app['CASHUP_OPTIONS'], 
            }),  
            DataItems(){
                console.log(this.JoinedOutlets,'this.JoinedOutlets.............');
                
                return this.JoinedOutlets?this.JoinedOutlets:this.Outlets
                
            },
            
            ItemSelector(){
                let CashupOptions = this.CashupOptions 
                let OutletTypes = this.OutletTypes
                return {
                    OutletTypes:OutletTypes,
                    CashupOptions:CashupOptions, 
                }
            },
            
            selectedCompany(){  
                return this.$store.getters.getSelectedCompany
            },  
            MY_LINKS(){  
                let thisLinks = this.MBS.actions.FIND_SUB_LINKS("stock",1,true) 
                return thisLinks
            }, 
            PATH_ITEM(){  
                let selectedCompany = this.selectedCompany
                let company_key = selectedCompany?selectedCompany.key:null
                if(!company_key){
                    this.MBS.actions.dialog({
                        show:true,
                        fixed:true,
                        title:"ERROR",
                        text:"No company is selected. Please, make sure you select the company.",
                        btnYes:"SELECT COMPANY",
                        action:{
                            code:PAGE_NAME+"=SELECT-COMPANY",
                        }
                    })
                    return null
                } 
                let P_DATA = (DATA.APP.SERVER+'/'+DATA.ITEMS.COMPANY_DATA.values).toUpperCase()+'/'+company_key+'/'
                let P_BRANDS = P_DATA+'SETTINGS/'+(DATA.ITEMS.STOCK_OUTLETS.values.toUpperCase())+'/'
 
                return P_BRANDS
            }, 
            HEADER_ITEMS(){
                return [ 
                    {id:1,name:"General",title:true}, 
                    {id:0,name:"",value:'icon_image',color:"",
                        icon:item=>{
                            if (item.outlet_type_code == 'warehouse') {
                                return 'mdi-warehouse'
                            }else if (item.outlet_type_code == 'restaurant') {
                                return 'mdi-silverware-fork-knife'
                            }else {
                                return 'mdi-store'
                            }
                        },background_color:"b2",size:35,tile:true,cellClass:'',class:' b ',align:'',show:true},   
                    {id:0,name:"Number",value:'no',show:false},   
                    {id:0,name:"code",align:"center",show:true},     
                    {id:0,name:"Location",value:"location_address",show:true},          
                    {id:0,name:"Name",value:"name",show:true},     
                    {id:0,name:"Type",value:"outlet_type_name",show:true},     
                    {id:0,name:"EIS SITE ID",value:"site_id",show:true},     
                    {id:0,name:"Auto",value:(this_,item)=>`${item.auto_dayshift?'Auto Start:0:0':''}  ${item.auto_close_time?', Auto Close:'+item.auto_close_time:''}`,align:"right",show:true},    
                    {id:0,name:"create",value:'created_at_',align:"right",show:false},    
                    {id:0,name:"update",value:'updated_at_',show:false},   
                    {id:0,name:"action",align:"right",show:true,item:[ 
                        {name:"Edit Outlet",action:"edit_action_item",icon:"edit"}, 
                        {name:"Update Display Info",action:"update_display_info",icon:mdiInformationVariantBoxOutline}, 
                        {name:"Update Dayshift Settings",action:"update_dayshift_settings",icon:"mdi-sun-clock-outline"}, 
                        {name:"Update Other Settings",action:"update_other_settings",icon:"mdi-window-shutter-cog"}, 
                        {name:"Archive Outlet",action:"archive_item",icon:"delete"}, 
                        {name:"View Items",action:"view_order_items",icon:"mdi-eye"}, 
                    ]}, 
                ]
            },
            HEADER_ITEMS2(){
                return [ 
                    {id:1,name:"General",title:true}, 
                    {id:0,name:"Number",value:'no',show:true},  
                    {id:0,name:"name",show:true}, 
                    {id:0,name:"code",align:"center",show:true},      
                    {id:0,name:"action",align:"right",show:true,item:[  
                        {name:"Edit "+this.NAME_ITEM,action:"edit_item",icon:"mdi-pencil"},
                        {name:"Delete "+this.NAME_ITEM,action:"delete_item",icon:"mdi-delete"},
                    ]}, 
                ]
            },   
        },
        methods: { 
            TABLE_ACTION(action,item){
                try {
                    let route = this.route
                    let fullPath = route?route.fullPath:null
                    console.log(action,'action');
                    if (action == "add_stock_outlet") {
                        let mbs_text = this.MBS.text.item_action("Stock Outlet","Add") 
                        this.MBS.actions.dialogConfirmPassword({
                            show:true,
                            fixed:true,
                            icon:"mdi-shield-lock-outline",
                            title:mbs_text.title,
                            text:mbs_text.text+" Enter your password to confirm.",
                            action:{
                                code:PAGE_NAME+'=ADD-STOCK-OUTLET',
                                phone_number_start:true,
                                all_users:true, 
                                get_access:{
                                    permission_type:"option",  
                                    action_name:"Start Stock Take"  
                                }
                            }
                        }) 
                    } 
                    if (action == "initialize_main_warehouse") {
                        let mbs_text = this.MBS.text.item_action("Main Warehouse","Initialize") 
                        this.MBS.actions.dialogConfirmPassword({
                            show:true,
                            fixed:true,
                            icon:"mdi-shield-lock-outline",
                            title:mbs_text.title,
                            text:mbs_text.text+" Enter your password to confirm.",
                            action:{
                                code:PAGE_NAME+'=INITIALIZE-MAIN-WAREHOUSE',
                                phone_number_start:true,
                                all_users:true, 
                                get_access:{
                                    permission_type:"option",  
                                    action_name:"Start Stock Take"  
                                }
                            }
                        }) 
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'TABLE_ACTION',
                        page:PAGE_NAME, 
                    }) 
                }
                
            },
            ITEM_ACTION(action,item,option){
                try {     
                    console.log(action,item,'***************');
                    if (action == "on_row_clicked") {
                         
                    }else if (action == "select_item") {
                         
                    }else if (action == "edit_item") {
                         
                    }else if (action == "edit_action_item") {
                        this.EDIT_OUTLETS(item)
                    }else if (action == "update_display_info") {
                         this.UPDATE_OUTLET_DISPLAY_INFO(item)
                    }else if (action == "update_dayshift_settings") {
                         this.UPDATE_OUTLET_DAYSHIFT_SETTINGS(item)
                    }else if (action == "update_other_settings") {
                         this.UPDATE_OUTLET_OTHER_SETTINGS(item)
                    }else{}
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ITEM_ACTION',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            EDIT_OUTLETS(item){
                try {      
                    this.ADDING_ITEM = {...DATA.ITEMS.STOCK_OUTLETS}
                    this.ADDING_ITEM.path =  this.MBS.actions.COMPANY_LINK(DATA.PATHS.stock_outlets,true)
                    this.ADDING_ITEM.fields =  DATA.FIELDS.outlets
                    this.ADDING_ITEM.edit_item_action =  {
                        action_do:'Edit',
                        action_doing:'Editing'
                    }
                    const items = this.Outlets
                    const original_item = items?.find(it=>it.key==item.key) 
                    setTimeout(() => {
                        this.MBS.events.$emit("ITEM_ACTION",{
                            NAME_ITEM:DATA.ITEMS.STOCK_OUTLETS.name,
                            action:"edit_item",
                            item:original_item?original_item:item,
                            // input:{
                            //     name:input,
                            //     code:barcode,
                            // }
                        })  
                    }, 50);
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'EDIT_OUTLETS',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            UPDATE_OUTLET_DISPLAY_INFO(item){
                try {    
                    this.ADDING_ITEM = {...DATA.ITEMS.STOCK_OUTLETS}
                    this.ADDING_ITEM.path =  this.MBS.actions.COMPANY_LINK(DATA.PATHS.stock_outlets,true)
                    this.ADDING_ITEM.fields =  DATA.FIELDS.outlets_display_info
                    this.ADDING_ITEM.add_item_action =  {
                        action_do:'Update',
                        action_doing:'updating'
                    }
                    const items = this.Outlets
                    const original_item = items?.find(it=>it.key==item.key) 
                    setTimeout(() => {
                        this.MBS.events.$emit("ITEM_ACTION",{
                            NAME_ITEM:DATA.ITEMS.STOCK_OUTLETS.name,
                            action:"edit_item",
                            item:original_item
                        })  
                    }, 50); 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'UPDATE_OUTLET_DISPLAY_INFO',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            UPDATE_OUTLET_DAYSHIFT_SETTINGS(item){
                try {    

                    this.ADDING_ITEM = {...DATA.ITEMS.STOCK_OUTLETS}
                    this.ADDING_ITEM.path =  this.MBS.actions.COMPANY_LINK(DATA.PATHS.stock_outlets,true)
                    this.ADDING_ITEM.fields =  DATA.FIELDS.outlets_dayshift_settings
                    this.ADDING_ITEM.add_item_action =  {
                        action_do:'Update',
                        action_doing:'updating'
                    }
                    const items = this.Outlets
                    const original_item = items?.find(it=>it.key==item.key) 
                    setTimeout(() => {
                        this.MBS.events.$emit("ITEM_ACTION",{
                            NAME_ITEM:DATA.ITEMS.STOCK_OUTLETS.name,
                            action:"edit_item",
                            item:original_item
                        })  
                    }, 50); 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'UPDATE_OUTLET_DAYSHIFT_SETTINGS',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            UPDATE_OUTLET_OTHER_SETTINGS(item){
                try {    
                    this.ADDING_ITEM = {...DATA.ITEMS.STOCK_OUTLETS}
                    this.ADDING_ITEM.path =  this.MBS.actions.COMPANY_LINK(DATA.PATHS.stock_outlets,true)
                    this.ADDING_ITEM.fields =  DATA.FIELDS.outlets_other_settings
                    this.ADDING_ITEM.add_item_action =  {
                        action_do:'Update',
                        action_doing:'updating'
                    }
                    const items = this.Outlets
                    const original_item = items?.find(it=>it.key==item.key) 
                    setTimeout(() => {
                        this.MBS.events.$emit("ITEM_ACTION",{
                            NAME_ITEM:DATA.ITEMS.STOCK_OUTLETS.name,
                            action:"edit_item",
                            item:original_item
                        })  
                    }, 50); 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'UPDATE_OUTLET_OTHER_SETTINGS',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            ADD_STOCK_OUTLET(){
                try {     
                    this.ADDING_ITEM = {...DATA.ITEMS.STOCK_OUTLETS}
                    this.ADDING_ITEM.path =  this.MBS.actions.COMPANY_LINK(DATA.PATHS.stock_outlets,true)
                    this.ADDING_ITEM.fields =  DATA.FIELDS.outlets
                    this.ADDING_ITEM.add_item_action =  {
                        action_do:'add',
                        action_doing:'Creating'
                    }
                    setTimeout(() => { 
                        this.MBS.events.$emit("ITEM_ACTION",{
                            NAME_ITEM:DATA.ITEMS.STOCK_OUTLETS.name,
                            action:"add_item",
                            input:{
                                name:"", 
                            }
                        })  
                    }, 50);
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ADD_STOCK_OUTLET',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            INITIALIZE_MAIN_WAREHOUSE(){
                try {      
                    const path =  this.MBS.actions.COMPANY_LINK(DATA.PATHS.stock_outlets+"0",true)  
                    const data = {
                        code:0,
                        key:"0", 
                        name:"Main Warehouse", 
                        outlet_type_code:"warehouse", 
                        location_address:"main", 
                    }
                    this.MBS.actions.progressDialog({
                        show:true,
                        fixed:false,
                        title:"Initializing.."
                    }) 
                    this.$store.dispatch("fi_update",{ 
                        action:DATA.ITEMS.STOCK_OUTLETS.values,
                        data:data,
                        path
                    }).then(res=>{
                        this.MBS.actions.progressDialog()
                        let mbs_text = this.MBS.text.item_action_success(DATA.ITEMS.STOCK_OUTLETS.values,"Initializing")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo,
                            
                        })
                        console.log(res,'re............e');
                        
                    }).catch(error=>{
                        console.log(error,'error.......');
                        this.MBS.actions.progressDialog()
                        let mbs_text = this.MBS.text.item_action_fail(DATA.ITEMS.STOCK_OUTLETS.values,"Initializing")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        }) 
                        
                    })
                     
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'INITIALIZE_MAIN_WAREHOUSE',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
             
            //---------------[MAIN FUNCTIONS]------------ 
            DIALOG_YES(action){ 
                try {
                    if (action.code) {
                        if (action.code ===PAGE_NAME+'=ADD-STOCK-OUTLET') {
                            if (action.YES) { 
                                this.ADD_STOCK_OUTLET() 
                            } else {
                                
                            }
                        } if (action.code ===PAGE_NAME+'=INITIALIZE-MAIN-WAREHOUSE') {
                            if (action.YES) { 
                                this.INITIALIZE_MAIN_WAREHOUSE() 
                            } else {
                                
                            }
                        }  
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'DIALOG_YES',
                        page:PAGE_NAME, 
                    }) 
                }  
            },  

            FEEDBACKS(time){ 
                try {
                    if (!time) { time=400 }
                    setTimeout(()=>{
                        let us = this.loggedUser 
                        let ps = this.processes
                        let ld = this.loading
                        let res = this.responses

                        //Check process 
                        if (ps) {
                            let gettingItems = ps.find(process=>{
                                return process.name == 'getting/'+this.VALUE_ITEMS
                            }) 
                        }else{
                            this.PAGE_LOAD =true
                        } 
                    },time)
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'FEEDBACKS',
                        page:PAGE_NAME, 
                    })  
                } 
            },  
        },
        beforeDestroy(){
            try { 
                this.MBS.events.$off('DIALOG_YES', this.DIALOG_YES);   
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'beforeDestroy',
                    page:PAGE_NAME, 
                })
            }
        },
        watch: { 
            loading:{ 
                handler:"FEEDBACKS",
                immediate:true
            } ,
            processes:{ 
                handler:"FEEDBACKS",
                immediate:true
            },
            responses:{ 
                handler:"FEEDBACKS",
                immediate:true
            } 
        },
    }
</script>
 
